"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = _interopRequireDefault(require("../Box"));

var _theme = _interopRequireDefault(require("../../theme"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizes = (0, _styledSystem.variant)({
  key: 'buttonSizes',
  prop: 'sizeVariant'
});

var themed = function themed(key) {
  return function (props) {
    return props.theme[key];
  };
};

var Button = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Button",
  componentId: "zk8qvs-0"
})({
  appearance: 'none',
  display: 'inline-block',
  textAlign: 'center',
  lineHeight: 'inherit',
  textDecoration: 'none'
}, (0, _styledSystem.compose)(_styledSystem.border, _styledSystem.buttonStyle, sizes), themed('Button'));
Button.defaultProps = {
  as: 'button',
  color: 'white',
  bg: 'blue',
  fontSize: 'inherit',
  fontWeight: 'bold',
  disabled: false,
  variant: 'default',
  sizeVariant: 'medium',
  theme: _theme["default"]
};
Button.propTypes = _objectSpread({}, _Box["default"].propTypes, {
  variant: _propTypes["default"].oneOf(['default', 'danger', 'secondary', 'primary', 'neutral', 'secondary-danger']),
  sizeVariant: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  onClick: _propTypes["default"].func,
  disabled: _propTypes["default"].bool
});
/** @component */

var _default = (0, _styledComponents.withTheme)(Button);

exports["default"] = _default;